import { HUBSPOT_PORTAL_ID } from "fond/constants";

export const hubSpotScriptURL = `https://js.hsforms.net/forms/embed/${HUBSPOT_PORTAL_ID}.js`;

export function injectHubSpotScript(): HTMLScriptElement | null {
  if (!HUBSPOT_PORTAL_ID) {
    console.error("HUBSPOT_PORTAL_ID is not set. HubSpot forms will not work.");
    return null;
  }
  const el = document.createElement("script");
  el.src = hubSpotScriptURL;
  document.body.appendChild(el);
  return el;
}
